import { Component } from '@/vue-property-decorator'
import {
  _CssVarCustom as CssVarCustom,
  _CssVarManagerBase
} from './cssVarCustom'
import { GetCssVarManager } from '../../../components/baseCssVarProvide'
import AdvertiseImgAssembled from './advertiseImgAssembled'
import AdvertiseImgIndividual from './advertiseImgIndividual'
import BasePropsConfig from '../components/basePropsConfig'
import BoxCut from '../../components/boxCut'
import MaskMaintain from '../../components/maskMaintain'
import OuterBox from './outerBox'
import _CssVarDefault from './cssVarDefault'
import _CssVarSmall from './cssVarSmall'
/** 卡片的类型声明 */
export type LandscapeLeftRightCssVarManager =
  GetCssVarManager<_CssVarManagerBase>
export const CssVarDefault = _CssVarDefault
export const CssVarSmall = _CssVarSmall
/** 游戏卡片-横向卡片 */
@Component<LandscapeLeftRight>({
  name: 'LandscapeLeftRight'
})
export default class LandscapeLeftRight extends BasePropsConfig {
  /** 自定义样式,没有默认指定内容 */
  public static CssVarCustom = CssVarCustom
  /** 获得默认样式 */
  public static CssVarDefault = CssVarDefault
  /** 获得小号样式 */
  public static CssVarSmall = CssVarSmall
  /** 通过传入原始数据,获取props */
  public static getProps = BasePropsConfig.getProps
  /** 渲染广告图片 */
  private renderAdvertsePicture() {
    const { isCompleteImage } = this.cardProps
    // 返回一张完整广告图
    if (isCompleteImage) {
      return <AdvertiseImgIndividual />
    }
    // 返回拼接的广告图
    else {
      return <AdvertiseImgAssembled />
    }
  }

  render() {
    const { isMaintain } = this.cardProps
    return (
      <OuterBox
        onClick={this.handleClickCard}
        cssVarManager={{ cssType: 'default' }}
      >
        {/* 放置在box-cut中的元素会被裁剪为圆角 */}
        <BoxCut cssVarManager={{ cssType: 'default' }}>
          {/* 渲染广告图片 */}
          {this.renderAdvertsePicture()}
          <template slot="cutSuspense">
            {/* 维护状态悬浮层 */}
            {isMaintain && (
              <MaskMaintain cssVarManager={{ cssType: 'default' }} />
            )}
          </template>
        </BoxCut>
      </OuterBox>
    )
  }
}
